import React, { Fragment } from "react";

export default function Footer({ web, version }) {
  const year = new Date().getFullYear();

  return (
    <Fragment>
      <div>
        <footer className="main-footer">
          <strong>
            Copyright © {year} <a href={web.startsWith("http") ? web : `https://${web}`}>simakor.id</a>.
          </strong>{" "}
          All rights reserved.
          <div className="float-right d-none d-sm-inline-block">
            <b>Version</b> {version}
          </div>
        </footer>
        <aside className="control-sidebar control-sidebar-dark" />
      </div>
    </Fragment>
  );
}

Footer.defaultProps = {
  web: "",
  version: "",
};
